import { createAction } from 'redux-actions';

export const getTutorialVideosAction = createAction('APP_GET_TUTORIALS');
export const getTutorialVideoAction = createAction('APP_GET_TUTORIAL');
